module.exports = __webpack_public_path__ + "static/media/kid13.c4ab8a2f.png";